import { http } from "./httpServices";
import { AQUA_CUSTOMER, CHECKOUT, GET_AQUA, PRODUCT } from "./constants";

export function getAquaGames(date = "2023-10-12") {
  // NEED TO REMOVE DEFAULT VALUE
  let category = "aqua_zone";
  return http.get(`${PRODUCT}${AQUA_CUSTOMER}`, {
    params: {
      date,
      category,
    },
  });
}

export function getAquaProduct(productId, date, slots) {
  return http.post(
    `${CHECKOUT}${GET_AQUA}`,
    { date, slots },
    { params: { productId } }
  );
}
